var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconMinus = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "icon"
}, /*#__PURE__*/React.createElement("path", {
  id: "icon_2",
  d: "M15.416 10.8332C6.80024 10.8332 13.1985 10.8332 4.58268 10.8332C4.35256 10.8332 4.16602 10.6466 4.16602 10.4165V9.58317C4.16602 9.35305 4.35256 9.1665 4.58268 9.1665C13.1985 9.1665 6.80024 9.1665 15.416 9.1665C15.6461 9.1665 15.8327 9.35305 15.8327 9.58317V10.4165C15.8327 10.6466 15.6461 10.8332 15.416 10.8332Z",
  fill: "#1051A1"
}))));
export default SvgIconMinus;